import { Box, Skeleton } from "@mui/material";
import { lazy, Suspense } from "react";

import type { LocationPickerProps } from "./LocationPicker.types";
import * as styles from "./LocationPicker.styles";

export type { LatLng, LocationPickerProps } from "./LocationPicker.types";

// Leaflet is only needed on the checkout page; keep it out of the main bundle.
const LocationPickerMap = lazy(() => import("./LocationPicker.map"));

export function LocationPicker(props: LocationPickerProps) {
  const height = props.height ?? 220;

  return (
    <Suspense
      fallback={
        <Box sx={styles.frame(height)}>
          <Skeleton variant="rectangular" width="100%" height="100%" />
        </Box>
      }
    >
      <LocationPickerMap {...props} />
    </Suspense>
  );
}
